// Normalize status from backend format
export const normalizeSubscriptionStatus = (status) => {
    if (typeof status === 'string' && status.startsWith('SubscriptionStatus.')) {
        return status.replace('SubscriptionStatus.', '');
    }
    return status;
}; 